export default "__VITE_ASSET__SUdmO9VM__"